module.exports = __webpack_public_path__ + "static/media/sm-logo-claim.d99260f7.svg";